import { createBrowserHistory as createHistory } from 'history'
const history = createHistory();
export default history;


export function forwardTo(location) {
    history.push(location);
  }